<template>
  <div v-html="content"></div>
</template>

<script>
export default {
  name: 'response',
  props: ['content']
}
</script>



// WEBPACK FOOTER //
// simple.vue?12047d5a